import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CoreServiceService } from '../core/core-service.service'; 

import { Status } from '../Models/status';
import { Ticket } from '../Models/ticket';
import { TARIFF } from '../Models/master-tariff';
@Injectable({
  providedIn: 'root'
})
export class TariffService {

  private BaseApiPath: string;
  constructor(private http: HttpClient, private coreService: CoreServiceService) {

    this.BaseApiPath = this.coreService.appSettings && this.coreService.appSettings.ParkBaseApiPath;

  }
  public GetTariff(ticket: Ticket): Observable<Ticket> {
    const ApiUrl = this.BaseApiPath + 'tariff/getticket';
    return this.http.post<Ticket>(ApiUrl, ticket);
  }
  public TariffCalculate(tariff: TARIFF): Observable<TARIFF> {
    const ApiUrl = this.BaseApiPath + 'tariff/TariffCalculate';
    return this.http.post<TARIFF>(ApiUrl, tariff);
  }
}
